<template>
  <print688 v-if="isPrint" :table-data="tableData" :target-year="targetYear" />
  <div v-else>
    <div>
      <search-nav @handleSearch="onClickSearch">
        <slot name="search">
          <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex ">
            <component
              v-for="(component, index) in stdSearchComponents"
              :key="index"
              :is="component['component']"
              :label="component['label']"
              :query="component['query']"
              :options="component['options']"
              :onClickSearch="onClickSearch"
              v-model="nav.value[component['value']]"
            />
          </div>
        </slot>
      </search-nav>

      <div class="flex justify-between items-center">
        <div style="font-size: 18px"><b>{{ $t('표시된 개수 :') }}</b><span>&nbsp;총 {{ tableData.length || 0 }} 대</span></div>
        <vs-button class="" color="secondary" type="border" @click="handlePrint">
          <div class="flex items-center ">
            <div class="mr-1 mt-1">
              <feather-icon icon="PrinterIcon" svgClasses="h-6 w-6" />
            </div>
            <div>{{ $t('인쇄') }}</div>
          </div>
        </vs-button>
      </div>

      <div class="dataTable">
        <table cellspacing="0" cellpadding="0" border="0">
          <thead>
          <tr>
            <th>{{ $t('회사명') }}</th>
            <th>{{ $t('공정명') }}</th>
            <th>{{ $t('공정내용') }}</th>
            <th>{{ $t('위험 기계·기구·설비') }}</th>
            <th>{{ $t('재해형태') }}</th>
            <th>{{ $t('등록일') }}</th>
            <th>{{ $t('만료일') }}</th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="(data, index) in tableData" :key="index">
            <td>{{ data['학교명'] }}</td>
            <td>{{ data['공정명'] }}</td>
            <td>{{ data['공정내용'] }}</td>
            <td>{{ data['위험기계기구설비'] }}</td>
            <td>{{ data['재해형태'] }}</td>
            <td>{{ data['등록일'] }}</td>
            <td>{{ data['만료일'] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import FileDownload from "@/components/FileDownload.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import NormalSearchNav137 from "@/views/boards/components/NormalSearchNav137.vue";
import TableListPage from "@/views/list/TableListPage.vue";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import SearchNav from "@/components/nav/SearchNav.vue";
import singlePageList from "@/views/boards/single-page/listIndex";
import searchComponent from "@/views/list/components/include";
import Print688 from "@/views/boards/single-page/688/Print.vue";

export default {
  components: {
    SearchNav,
    SearchNavYearMonth,
    TableListPage,
    NormalSearchNav137,
    FileDownload,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    Print688,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    docProjectId: String | Number,
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    hasAdminPermission() {
      return parseInt(this.$store.state.auth.userInfo.is_superuser) === 1;
    },
    stdSearchComponents() {
      if (singlePageList[`688_pagelist`]) {
        const getComponents = singlePageList[`688_pagelist`].components
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              component.component = searchComponent[component['component']];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.form && value) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    EnableSave: {
      immediate: true,
      handler() {
        this.$emit("EnableSave", this.EnableSave);
      },
    },
  },
  mounted() {
    this.loadBoardPostList();
  },
  data() {
    return {
      targetYear: new Date().getFullYear(),
      tableData: [],
      EnableSave: false,
      form: {
        fileList: [],
      },
      nav: {
        value: {},
      },
    };
  },
  methods: {
    save() {},
    async loadBoardPostList(page = 1) {
      const projectId = this.$route.params.proj_id;
      const boardId = 688;
      const perPage = 100;

      const conditions = singlePageList[`688_pagelist`].getConditions(this.nav)

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId, page, perPage, conditions });
      const postListInfo = this.$store.state.board.postListInfo;
      this.list = postListInfo.data;
      if (page === 1) {
        this.tableData = [];
      }
      for (const data of this.list) {
        const content = this.getContent(data);
        if ((content.riskAppraisalList.length || 0) > 0) {
          for (const riskAppraisal of content.riskAppraisalList) {
            this.tableData.push({
              '학교명': content.stdInfo.com_name || '-',
              '공정명': content.stdInfo.공정명 || '-',
              '공정내용': riskAppraisal.사진내용 || '-',
              '위험기계기구설비': riskAppraisal.input_5 || '-',
              '재해형태': riskAppraisal.input_3 || '-',
              '등록일': riskAppraisal.등록일 || '-',
              '만료일' : riskAppraisal.만료일 || '-',
            });
          }
        }
      }

      if (postListInfo.current_page < postListInfo.last_page) {
        await this.loadBoardPostList(page + 1);
      }
    },
    getContent(data) {
      if (data.post_content) {
        try {
          const content = JSON.parse(data.post_content);
          if (content.body) {
            return content.body;
          }
          return content;
        } catch (e) {
          return {};
        }
      }
    },
    async onClickSearch(data) {
      await this.loadBoardPostList();

      const column = this.nav.value.column
      this.tableData = this.tableData.filter((data, index) => {
        let returnData = true
        if (column.keyword)  {
          if (column.head === '공정내용') returnData = data['공정내용'].includes(column.keyword)
          if (column.head === '위험 기계·기구·설비') returnData = data['위험 기계·기구·설비'].includes(column.keyword)
          if (column.head === '재해형태') returnData = data['재해형태'].includes(column.keyword)
        }
        return returnData
      })
    },
    handlePrint() {
      // 프린트
      this.isPrint = true;

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = `${g_oBeforeBody}`;
        };
        window.print();
        location.reload();
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.dataTable {
  margin-top: 14px;
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    thead {
      th {
        padding: 17px 0;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #3c3c3c;
        background-color: #fafafa;
        border: 1px solid #cdcdcd;
        width: 14.28%;
      }
    }
    tbody {
      td {
        text-align: center;
        font-size: 14px;
        padding: 14px 10px;
        border: 1px solid #cdcdcd;
        word-break: keep-all;
        background-color: #fff;
      }
    }
  }
}
</style>
